import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.commissions')
  .factory('CommissionsAPI', CommissionsAPI);

function CommissionsAPI(): BringozApi {
  return {
    base: `/commissions`,
    infiniteScroll: {
      address: `/commissions`,
      cmd: 'GET'
    },
    actions: {
      addCredit: {
        address: 'actions/credit',
        cmd: 'PUT',
        updateable: false
      },
      addDebt: {
        address: 'actions/debit',
        cmd: 'PUT',
        updateable: false
      },
      export: {
        address: 'actions/export',
        cmd: 'POST',
        updateable: false
      },
      totals: {
        address: 'totals/summary',
        cmd: 'GET'
      },
      payManually: {
        address: 'actions/payManually',
        cmd: 'POST',
        updateable: false
      },
      pay: {
        address: 'actions/pay',
        cmd: 'POST',
        updateable: false
      },
      editPrice: {
        address: '{id}/editPrice',
        cmd: 'POST',
        updateable: false
      },
      bulkEditPrice: {
        address: 'bulkEditPrice',
        cmd: 'POST',
        updateable: false
      },
      updateOne: {
        address: '{commissionId}',
        cmd: 'POST',
        updateable: false
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getLogsTimeline: {
        address: '{commissionId}/timeline',
        cmd: 'GET',
        updateable: false
      },
    }
  }
}
